module.exports = __webpack_public_path__ + "img/reload-icon.abb5fef2.svg";